import moment from "moment-timezone";

export const compareBy = (a, b, sortBy) => {
  const nameA = a[sortBy];
  const nameB = b[sortBy];

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

export const checkIfLastVisitIsInLastWeek = (lv) => {
  const lastVisit = moment(lv);

  // Get start and end of last week
  const startOfLastWeek = moment().startOf("week").subtract(1, "week");
  const endOfLastWeek = moment()
    .startOf("week")
    .subtract(1, "day")
    .endOf("day");

  // Check if lastVisit is within last week
  const isLastWeek = lastVisit.isBetween(
    startOfLastWeek,
    endOfLastWeek,
    null,
    "[]"
  );

  return isLastWeek;
};

export const checkIfThisWeek = (lv) => {
  const lastVisit = moment(lv);
  const startOfThisWeek = moment().startOf("week");
  const endOfThisWeek = moment().endOf("week");
  const isThisWeek = lastVisit.isBetween(
    startOfThisWeek,
    endOfThisWeek,
    null,
    "[]"
  );
  return isThisWeek;
};
